import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SettingsService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class MetroGaurd implements CanActivate {

  constructor(private settingsService : SettingsService, private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const metroAuth = this.settingsService.metroOnly;
    if (metroAuth) {
      this.router.navigateByUrl('/404')
      return false;
    } else {
      return true;
    }
  }

}
